"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_native_1 = require("react-native");
var defaultProps = {
    value: false,
    disabled: false,
    activeColor: 'green',
    inactiveColor: 'gray'
};
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLAtomSwitch = function (_a) {
    var value = _a.value, onChange = _a.onChange, disabled = _a.disabled, activeColor = _a.activeColor, inactiveColor = _a.inactiveColor;
    // Returns complete ATLAtomSwitch
    return (react_1.default.createElement(react_native_1.Switch, { disabled: disabled, value: value, onValueChange: onChange, thumbColor: react_native_1.Platform.OS === 'ios' ? undefined : 'white', trackColor: {
            false: inactiveColor || defaultProps.inactiveColor,
            true: activeColor || defaultProps.activeColor
        } }));
};
exports.ATLAtomSwitch.defaultProps = defaultProps;
exports.ATLAtomSwitch.displayName = 'ATLAtomSwitch';
